import { memo } from 'react';
import type { ItemWithAllPrices } from '@/api/items/items.types';

export const ItemBedarfCell = memo(function ItemBedarfCell({ item }: { item: ItemWithAllPrices }) {
  const total =
    item.quantityOnStock -
    item.quantityOrderedByCustomers +
    item.quantityOrderedFromVendors;
  const value = item.minInventory > total ? item.minInventory - total : 0;
  const hasNeed = value > 0;

  return (
    <span style={{
      width: '100%',
      textAlign: 'right',
      display: 'block',
      color: hasNeed ? 'var(--warn)' : 'var(--ink-3)',
      fontWeight: hasNeed ? 600 : 400,
    }}>
      {hasNeed ? value : '—'}
    </span>
  );
});
